<div class="yf-row center gap-4">
  <ion-icon name="battery-charging-outline" color="light" class="medium-icon"></ion-icon>
  <ion-text color="warning" [class]="$textClass()">{{$percentage()}}<span [class]="$umClass()">%</span></ion-text>
</div>